<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：商户-提现管理
      -->
  <div class="user clearfix">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商户名称">
          <el-input size="small" v-model="searchForm.search" placeholder="请输入商户名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getTableList">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="workerlist" border style="width: 100%">
          <el-table-column type="index" width="80" align="center" label=""></el-table-column>
          <!-- <el-table-column prop="orderNo" label="提现单号">
          </el-table-column> -->
          <el-table-column prop="supplier.link_name" width="120" align="center" label="姓名">
          </el-table-column>
          <el-table-column prop="supplier.link_phone" width="120" align="center" label="手机号">
          </el-table-column>
          <el-table-column prop="supplier.name" width="120" align="center" label="商户名称"></el-table-column>
          <el-table-column prop="money" width="120" align="center" label="提现金额">
            <template slot-scope="scope">
              <span style="color: red">￥{{ scope.row.money ? scope.row.money : 0.00 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="price_handling" width="120" align="center" label="手续费">
            <template slot-scope="scope">
              <span style="color: orange">￥{{ scope.row.price_handling ? scope.row.price_handling : 0.00 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" width="120" align="center" label="实际到账金额">
            <template slot-scope="scope">
              <span style="color:green">￥{{ scope.row.price ? scope.row.price : 0.00 }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="account.alipay_name" width="120" align="center" label="支付宝名称"></el-table-column>
          <el-table-column prop="account.bank_name" width="120" align="center" label="支付宝账号"></el-table-column>
          <el-table-column prop="account.bank_account" width="120" align="center" label="银行开户名"></el-table-column>
          <el-table-column prop="account.bank_card" width="120" align="center" label="银行卡号"></el-table-column>
          <el-table-column prop="pay_type.value" width="120" align="center" label="打款方式">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.pay_type.value == 20">{{ scope.row.pay_type.text }}</el-tag>
              <el-tag v-else-if="scope.row.pay_type.value == 10">{{ scope.row.pay_type.text }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="apply_status.value" width="120" align="center" label="申请状态">
            <template slot-scope="scope">
              <el-tag type="warning" v-if="scope.row.apply_status.value == 10">{{ scope.row.apply_status.text }}</el-tag>
              <el-tag v-else-if="scope.row.apply_status.value == 20">{{ scope.row.apply_status.text }}</el-tag>
              <el-tag type="danger" v-else-if="scope.row.apply_status.value == 30">{{ scope.row.apply_status.text
              }}</el-tag>
              <el-tag type="success" v-else-if="scope.row.apply_status.value == 40">{{ scope.row.apply_status.text
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="reject_reason" width="120" align="center" label="审核建议"></el-table-column>
          <!-- <el-table-column prop="remarks" width="120" align="center" label="备注"></el-table-column> -->
          <el-table-column prop="audit_time" width="120" align="center" label="审核时间">
            <template slot-scope="scope">
              <span>{{ scope.row.audit_time == 0 ? '' : scope.row.audit_time }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="120" align="center"></el-table-column>
          <el-table-column prop="update_time" label="更新时间" width="120" align="center"></el-table-column>

          <el-table-column label="操作" width="150" align="center" fixed="right">
            <template slot-scope="scope">
				<el-button @click="navchange(scope.row)" type="primary" size="small" v-if="scope.row.apply_status.value != 20 && scope.row.apply_status.value != 40">审核</el-button>
              <el-button v-else type="primary" disabled>已审核</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="getworker.page" :page-sizes="[10, 20, 30, 40]" :page-size="getworker.rows"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <!--审核-->
    <el-dialog title="审核" :visible.sync="dialogVisible" width="50%">
      <el-form :model="workerinfo" :rules="rules" ref="formName">
        <el-form-item label="是否允许:" prop="apply_status">
          <el-radio-group v-model="workerinfo.apply_status">
            <el-radio :label="20">通过</el-radio>
            <el-radio :label="30">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核建议" prop="reject_reason">
          <el-input v-model="workerinfo.reject_reason" type="textarea" :rows="2" placeholder="请输入内容"
            autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changestatus">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SupplierApi from "@/api/supplier.js";
import Submit from "./dialog/Submit";
import request from "@/utils/request";
import { deepClone } from "@/utils/base";
export default {
  components: {
    Submit
  },
  data() {
    return {
      rules: {
        apply_status: [{ required: true, message: "请选择！", trigger: "blur" }]
      },
      workerinfo: {
        id: "",
        apply_status: 20,
        reject_reason: ""
      },
      searchForm: {
        search: ""
      },
      dialogVisible: false,
      workerlist: [],
      getworker: {
        page: 1,
        rows: 10
      },
      total: 0
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  mounted() {
    console.log("1212", this.workerlist);
  },
  methods: {
    // 进入审核页面
    navchange(e) {
      this.workerinfo.id = e.id;
      // this.workerinfo.apply_status = e.apply_status.value;
      this.workerinfo.reject_reason = e.reject_reason;
      this.dialogVisible = true;
    },
    // 修改审核状态
    changestatus() {
      let that = this;

      this.$refs["formName"].validate(valid => {
        if (valid) {
          request
            ._post("/shop/supplier.Cash/submit", {
              id: that.workerinfo.id,
              apply_status: that.workerinfo.apply_status,
              reject_reason: that.workerinfo.reject_reason
            })
            .then(res => {
              if (res.code == 1) {
                that.$message({
                  type: "success",
                  message: res.msg
                });
              }
              that.getTableList();
            });
        } else {
          console.log("选择", that.workerinfo);
        }
      });

      this.dialogVisible = false;
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.getworker.page = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.getworker.rows = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let that = this;
      let params = that.getworker;
      params.search = that.searchForm.search;
      request._post("/shop/supplier.Cash/index", params).then(res => {
        // console.log(res, 121);
        this.workerlist = res.data.list.data;
        this.total = res.data.list.total;
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/cash/cashmoney/suppliercash/cash.vue